module.exports = __webpack_public_path__ + "img/sidebar_selected_flood_sensor.e9d63481.svg";